import { History } from "history";

import {
  BannerDto,
  CreateBannerRequest,
  PaginateQuery,
  UpdateBannerRequest,
} from "../../interfaces";
import { Paginated } from "../../models";
import {
  ADD_BANNER,
  ADD_BANNER_ERROR,
  ADD_BANNER_SUCCESS,
  DELETE_BANNER,
  DELETE_BANNER_CONSENT,
  DELETE_BANNER_ERROR,
  DELETE_BANNER_SUCCESS,
  GET_BANNER,
  GET_BANNERS,
  GET_BANNERS_ERROR,
  GET_BANNERS_SUCCESS,
  GET_BANNER_ERROR,
  GET_BANNER_SUCCESS,
  TOGGLE_ADD_EDIT_BANNER_MODAL,
  ToggleAddEditBannerModalAction,
  UPDATE_BANNER,
  UPDATE_BANNER_ERROR,
  UPDATE_BANNER_SUCCESS,
  UPLOAD_BANNER_IMAGE,
  UPLOAD_BANNER_IMAGE_ERROR,
  UPLOAD_BANNER_IMAGE_SUCCESS,
} from "../banner/actionTypes";
import {} from "./actionTypes";
import { MediaDto } from "../../interfaces/media";
import {
  GetBannersAction,
  GetBannersSuccessAction,
  GetBannersErrorAction,
  GetBannerAction,
  GetBannerSuccessAction,
  GetBannerErrorAction,
  AddBannerAction,
  AddBannerSuccessAction,
  AddBannerErrorAction,
  UpdateBannerAction,
  UpdateBannerSuccessAction,
  UpdateBannerErrorAction,
  DeleteBannerConsentAction,
  DeleteBannerAction,
  DeleteBannerSuccessAction,
  DeleteBannerErrorAction,
  UploadBannerImageAction,
  UploadBannerImageSuccessAction,
  UploadBannerImageErrorAction,
} from "../banner/actionTypes";

//#region Get Banners

export const getBanners = (
  request: PaginateQuery,
  history: History
): GetBannersAction => {
  return {
    type: GET_BANNERS,
    payload: { request, history },
  };
};

export const getBannersSuccess = (
  response: Paginated<BannerDto>
): GetBannersSuccessAction => {
  return {
    type: GET_BANNERS_SUCCESS,
    payload: response,
  };
};

export const getBannersError = (error: any): GetBannersErrorAction => {
  return {
    type: GET_BANNERS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Banner

export const getBanner = (id: string, history: History): GetBannerAction => {
  return {
    type: GET_BANNER,
    payload: { id, history },
  };
};

export const getBannerSuccess = (
  response: BannerDto
): GetBannerSuccessAction => {
  return {
    type: GET_BANNER_SUCCESS,
    payload: response,
  };
};

export const getBannerError = (error: any): GetBannerErrorAction => {
  return {
    type: GET_BANNER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Banner

export const addBanner = (
  request: CreateBannerRequest,
  history: History
): AddBannerAction => {
  return {
    type: ADD_BANNER,
    payload: { request, history },
  };
};

export const addBannerSuccess = (): AddBannerSuccessAction => {
  return {
    type: ADD_BANNER_SUCCESS,
    payload: null,
  };
};

export const addBannerError = (error: any): AddBannerErrorAction => {
  return {
    type: ADD_BANNER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Banner

export const updateBanner = (
  id: string,
  request: UpdateBannerRequest,
  history: History
): UpdateBannerAction => {
  return {
    type: UPDATE_BANNER,
    payload: { id, request, history },
  };
};

export const updateBannerSuccess = (): UpdateBannerSuccessAction => {
  return {
    type: UPDATE_BANNER_SUCCESS,
    payload: null,
  };
};

export const updateBannerError = (error: any): UpdateBannerErrorAction => {
  return {
    type: UPDATE_BANNER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Banner

export const deleteBannerConsent = (id: string): DeleteBannerConsentAction => {
  return {
    type: DELETE_BANNER_CONSENT,
    payload: id,
  };
};

export const deleteBanner = (
  id: string,
  history: History
): DeleteBannerAction => {
  return {
    type: DELETE_BANNER,
    payload: { id, history },
  };
};

export const deleteBannerSuccess = (): DeleteBannerSuccessAction => {
  return {
    type: DELETE_BANNER_SUCCESS,
    payload: null,
  };
};

export const deleteBannerError = (error: any): DeleteBannerErrorAction => {
  return {
    type: DELETE_BANNER_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload Banner Home Image

export const uploadBannerImage = (
  file: File,
  history: History,
  bannerId?: string
): UploadBannerImageAction => {
  return {
    type: UPLOAD_BANNER_IMAGE,
    payload: { file, history, bannerId },
  };
};

export const uploadBannerImageSuccess = (
  media: MediaDto
): UploadBannerImageSuccessAction => {
  return {
    type: UPLOAD_BANNER_IMAGE_SUCCESS,
    payload: media,
  };
};

export const uploadBannerImageError = (
  error: any
): UploadBannerImageErrorAction => {
  return {
    type: UPLOAD_BANNER_IMAGE_ERROR,
    payload: error,
  };
};

//#endregion

//#region add edit banner modal
export const toggleAddEditBannerModal = (): ToggleAddEditBannerModalAction => {
  return {
    type: TOGGLE_ADD_EDIT_BANNER_MODAL,
    payload: null,
  };
};
//#endregion
